export var GameState;
(function (GameState) {
    GameState["LIVE"] = "live";
    GameState["VIDEO"] = "video";
    GameState["MAINTENANCE"] = "maintenance";
})(GameState || (GameState = {}));
